export const makeListQueryKey = (projectId) => [projectId, 'documents'];
